import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularGift: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_gift"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="gift icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 18 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M11.5 0C13.2949 0 14.75 1.45507 14.75 3.25C14.75 3.89455 14.5624 4.49528 14.2387 5.00054L16.75 5C17.4404 5 18 5.55964 18 6.25V9.75C18 10.3544 17.571 10.8586 17.0009 10.9748L17 16.75C17 18.483 15.6435 19.8992 13.9344 19.9949L13.75 20H4.25C2.51697 20 1.10075 18.6435 1.00514 16.9344L1 16.75L1.00005 10.975C0.429465 10.8592 0 10.3548 0 9.75V6.25C0 5.55964 0.559644 5 1.25 5L3.76126 5.00054C3.43763 4.49528 3.25 3.89455 3.25 3.25C3.25 1.45507 4.70507 0 6.5 0C7.50555 0 8.40443 0.456664 9.00058 1.17391C9.59557 0.456664 10.4945 0 11.5 0ZM8.25 10.999H2.5V16.75C2.5 17.6682 3.20711 18.4212 4.10647 18.4942L4.25 18.5H8.25V10.999ZM15.5 10.999H9.75V18.5H13.75C14.6682 18.5 15.4212 17.7929 15.4942 16.8935L15.5 16.75V10.999ZM8.25 6.5H1.5V9.5L8.25 9.499V6.5ZM16.5 9.5V6.5H9.75V9.499L16.5 9.5ZM11.5 1.5C10.5335 1.5 9.75 2.2835 9.75 3.25V4.999H11.524L11.6435 4.9942C12.5429 4.92119 13.25 4.16817 13.25 3.25C13.25 2.2835 12.4665 1.5 11.5 1.5ZM6.5 1.5C5.5335 1.5 4.75 2.2835 4.75 3.25C4.75 4.16817 5.45711 4.92119 6.35647 4.9942L6.476 4.999H8.25V3.25L8.2442 3.10647C8.17119 2.20711 7.41817 1.5 6.5 1.5Z" />
      </svg>
    </span>
  );
};

export { RegularGift };
